module.exports = __webpack_public_path__ + "static/media/background.325430de.png";